// @flow
import isPointGeotype from './isPointGeotype';

export const radiusStringToInt = (radius: ?string) =>
  radius === 'auto' ? null : parseInt(radius, 10);

export const radiusIntToString = (radius: ?number, geoType: ?string) => {
  if (!radius && isPointGeotype(geoType)) {
    return 'auto';
  }
  return radius ? String(radius) : null;
};
